import { useState } from "react"
import { NavLink } from "react-router-dom"
import { Button } from "@mantine/core"
import { Icon } from "@material-tailwind/react"
import { Switch } from "@mantine/core"

export const classNames = (...classes) => classes.filter(Boolean).join(" ")

export const StatusPill = ({ value }) => {
  const statusColor = {
    Pendiente: "bg-green-100 text-green-700",
    Dentro: "bg-green-100 text-green-700",
    Fallido: "bg-red-100 text-red-700",
    Cerrado: "bg-yellow-100 text-yellow-700",
    "Cerrado por admin": "bg-yellow-100 text-yellow-700",
    "Denegado por guardia": "bg-red-100 text-red-700",
  }

  return (
    <span
      className={classNames(
        "inline-block  rounded px-3 py-1 text-sm font-semibold",
        statusColor[value] ? statusColor[value] : "bg-gray-200 text-gray-700"
      )}>
      {value}
    </span>
  )
}

export const DateCell = ({ value }) => {
  const date = new Date(value).toISOString().substring(0, 10)

  const dateData = date.split("-")

  const dateFormated = dateData[0] + "-" + dateData[1] + "-" + dateData[2]
  return (
    <span className={classNames("inline-block rounded text-sm font-semibold ")}>
      {dateFormated}
    </span>
  )
}

export const EntryExitCell = ({ value }) => {
  const { date, time } = value

  const dateFormated = date ? new Date(date).toISOString().substring(0, 10) : "Sin fecha"

  const timeFormated = date ? new Date(date).toLocaleTimeString() : "Sin hora"
  return (
    <>
      <p className={classNames("rounded text-sm font-semibold")}>
        <span className='bg-gray-500 rounded px-2 py-1 text-sm ml-1 text-gray-700'>Fecha</span>{" "}
        {dateFormated}
      </p>
      <p className={classNames("rounded text-sm font-semibold mt-4 ml-2")}>
        <span className='bg-gray-500 rounded px-2 py-1 text-sm ml-1 text-gray-700'>Hora</span>{" "}
        {timeFormated}
      </p>
    </>
  )
}

export const DetailCell = ({ value, route, text, iconName }) => {
  const dataId = value.original._id

  return (
    <div className='flex justify-start items-center mt-2'>
      <Button className='rounded-sm px-0 py-1 text-sm font-semibold mr-2 bg-gray-700 text-white focus:outline-none hover:bg-gray-600'>
        <NavLink
          to={`${route.parent}${route.child}/:${dataId}`}
          exact='true'
          className='flex items-center gap-4 text-sm text-white font-bold px-4 py-3 rounded-lg'
          activeclassname='bg-gradient-to-tr from-light-blue-500 to-light-blue-700 shadow-md'>
          {iconName && <Icon name={iconName} />}
          {text}
        </NavLink>
      </Button>
    </div>
  )
}

export const EditActions = ({ value, onEdit, onDelete }) => {
  return (
    <div className='flex justify-start items-center mt-2'>
      <Button
        className='rounded-sm px-5 py-1 text-sm font-semibold mr-2 bg-gray-700 text-white focus:outline-none hover:bg-gray-600 '
        onClick={() => {
          onEdit(value)
        }}>
        <Icon name={"edit"} size='xs' />
      </Button>
      <Button
        className='rounded-sm px-5 py-1 text-sm font-semibold mr-2 bg-red-500 text-white focus:outline-none hover:bg-red-400'
        onClick={() => {
          onDelete(value)
        }}>
        <Icon name={"delete"} size='xs' />
      </Button>
    </div>
  )
}

export const GetQrCode = ({ value, onClick }) => {
  return (
    <div className='flex justify-start items-center mt-2'>
      <Button
        className='rounded-sm px-5 py-1 text-sm font-semibold mr-2 bg-gray-700 text-white focus:outline-none hover:bg-gray-600 '
        onClick={() => {
          onClick(value)
        }}>
        <Icon name={"qr_code_scanner"} size='xl' />
      </Button>
    </div>
  )
}

// src/Table.js
export const AvatarCell = ({ value, column, row }) => {
  if (!row.original[column.imgAccesor]) {
    return (
      <div className='flex items-center'>
        <div className='ml-4'>
          <div className='flex justify-between  whitespace-nowrap text-sm text-gray-900 w-full lg:w-auto lg:table-cell lg:static'>
            {value}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className='flex items-center'>
      <div className='flex-shrink-0 h-10 w-10'>
        <img
          className='h-10 w-10 rounded-full'
          src={`https://access-control-cbdesarrollo.s3.amazonaws.com/${
            row.original[column.imgAccesor]
          }`}
          alt=''
        />
      </div>
      <div className='ml-4'>
        <div className='flex justify-between  whitespace-nowrap text-sm text-gray-900 w-full lg:w-auto lg:table-cell lg:static'>
          {value}
        </div>
      </div>
    </div>
  )
}

export const ToggleActiveCell = ({ value, onChange }) => {
  const [checked, setChecked] = useState(value.original.active)
  return (
    <Switch
      checked={checked}
      onChange={(event) => {
        onChange(value)
        setChecked(event.currentTarget.checked)
      }}
    />
  )
}
